module.exports = require('./helpers/bundle-url').getBundleURL('3ZIKl') + "logo.c51670a8.svg";